import { useLocale } from 'next-intl';
import { Link } from '@/i18n/routing';
import { useSuspenseQuery } from '@apollo/client';
import { ShowBlogs, ShowBlog } from '@/query';
import { Pagination } from './Pagination';

export const Blogs = ({ page = 1, tab }) => {
  const locale = useLocale();

  const { data } = useSuspenseQuery(ShowBlogs, {
    variables: {
      filter: { locale },
      page,
    },
    errorPolicy: 'ignore',
  });

  const blogs = data?.blogs?.collection || [];
  const totalPages = data?.blogs?.metadata?.totalPages || 1;

  return blogs?.length ? (
    <>
      {blogs.map((blog, i) => (
        <div key={i} className="mb-16 last:mb-0">
          <div className="text-primary-800 max-sm:text-2xl sm:text-[32px] font-semibold mb-8">
            <Link href={`/blogs?section=${blog.slug}`}>{blog.name}</Link>
          </div>
          <div>
            <div className="tab-content grid min-[600px]:max-sm:grid-cols-2 list-md:grid-cols-2 2xl:max-3xl:grid-cols-3 3xl:grid-cols-4 gap-y-6 gap-x-8">
              {[...Array(blog?.posts?.metadata?.totalPages || 0).keys()].map(
                (page) => (
                  <Posts
                    key={page}
                    page={page + 1}
                    blog={blog}
                    locale={locale}
                  />
                )
              )}
            </div>
          </div>
        </div>
      ))}
      {totalPages > 1 && (
        <div className="max-sm:py-8 sm:max-lg:py-8 lg:py-[46px] 3xl:rounded-10">
          <Pagination tab={tab} page={page} totalPages={totalPages} />
        </div>
      )}
    </>
  ) : null;
};

const Posts = ({ page, blog, locale }) => {
  const skip = page === 1;

  const { data } = useSuspenseQuery(ShowBlog, {
    variables: {
      slug: blog.slug,
      locale,
      page,
    },
    skip,
    errorPolicy: 'ignore',
  });

  const posts =
    (skip ? blog?.posts?.collection : data?.showBlog?.posts?.collection) || [];

  return posts?.length
    ? posts.map((item) => (
        <div key={item.slug} className="flex flex-col gap-1 min-w-0">
          <Link
            href={`/blogs/${blog.slug}/${item.slug}`}
            className="text-slate-500 text-base font-normal underline leading-tight truncate"
          >
            {item.title}
          </Link>
        </div>
      ))
    : null;
};
